type Listener = (resource: string) => void
const listeners = new Set<Listener>()

export function onUnauthorized(fn: Listener): () => void {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

export function emitUnauthorized(resource: string): void {
  listeners.forEach((fn) => fn(resource))
}
